import { useNavigate } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../Components/Buttons/primary-button.js";

import renderColoradoRenterRewards from "../../Organisms/Modals/Programs/colorado-renter-rewards";

import { useAppEssentials, usePrograms } from "../../CustomHooks/Queries";
import { useLogout } from "../../CustomHooks/Mutations";

import { useModalContext } from "../../Contexts/ModalContext.js";

import { onSignOut } from "../../Utils/helpers.js";

import {
  Disclosures,
  Terms,
  Privacy,
  ProfileOutline,
  SupportThin,
  Out,
  CircleQuestionThin,
  ChevronLeft,
} from "../../Assets/Icons";

import "./profile.scss";
import "./profile-responsive.scss";

const RowChevron = () => (
  <svg className="pc-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 4l4 4-4 4" stroke="#8B8FA3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Profile() {
  const navigate = useNavigate();

  const modalContext = useModalContext();

  const { show: showIntercom } = useIntercom();

  const { isLoading: isLoadingAppEssentials, data: appEssentialsData } = useAppEssentials();
  const { isLoading: isLoadingPrograms, data: programs } = usePrograms({
    enabled: appEssentialsData?.propertyHasProgram ?? false,
  });

  const { mutate: InitLogout } = useLogout({
    onSettled: onSignOut,
  });

  const handleLearnMoreClick = () => {
    if (programs?.my_program?.id === "colorado_renter_rewards") {
      renderColoradoRenterRewards(modalContext, {
        skipProgramIntro: true,
      });
    }
  };

  const isLoading = isLoadingAppEssentials || isLoadingPrograms;

  return (
    <div className="profile-overlay">
      <div className="profile-card">
        <div className="pc-header">
          <button className="pc-back" onClick={navigate.bind(this, -1)} aria-label="Go back">
            <ChevronLeft />
          </button>
          <span className="pc-title">Profile</span>
        </div>

        {isLoading ? (
          <div className="loading-content">
            <CircularProgress />
          </div>
        ) : (
          <>
            {!!programs?.my_program && (
              <div className="program-info-card">
                <div className="program-content">
                  <img
                    src={programs?.my_program?.image_src?.primary}
                    alt={programs?.my_program?.name}
                    className="program-logo"
                  />
                  <h4 className="program-title">You're eligible for {programs?.my_program?.name} program.</h4>
                  <p className="program-description">{programs?.my_program?.property_benefit_briefing}</p>
                  <PrimaryButton className="dark-theme" onClick={handleLearnMoreClick}>
                    Learn More
                  </PrimaryButton>
                </div>
              </div>
            )}

            <div className="pc-section-header">Account</div>
            <div className="pc-row" onClick={navigate.bind(this, "/profile/personal-information")}>
              <div className="pc-icon"><ProfileOutline /></div>
              <div className="pc-text">
                <span className="pc-label">Personal Information</span>
                <span className="pc-sub">Name, email, phone</span>
              </div>
              <RowChevron />
            </div>

            <div className="pc-section-header">Support</div>
            <div className="pc-row" onClick={showIntercom}>
              <div className="pc-icon"><SupportThin /></div>
              <div className="pc-text">
                <span className="pc-label">Contact Support</span>
                <span className="pc-sub">Get help from our team</span>
              </div>
              <RowChevron />
            </div>
            <div className="pc-row" onClick={window.open.bind(this, "https://www.stake.rent/faq", "_blank")}>
              <div className="pc-icon"><CircleQuestionThin /></div>
              <div className="pc-text">
                <span className="pc-label">FAQ</span>
                <span className="pc-sub">Frequently asked questions</span>
              </div>
              <RowChevron />
            </div>

            <div className="pc-section-header">Agreement</div>
            <div className="pc-row" onClick={window.open.bind(this, "https://www.stake.rent/legal/terms-of-use", "_blank")}>
              <div className="pc-icon"><Terms /></div>
              <div className="pc-text">
                <span className="pc-label">Terms of Service</span>
                <span className="pc-sub">User agreement</span>
              </div>
              <RowChevron />
            </div>
            <div className="pc-row" onClick={window.open.bind(this, "https://www.stake.rent/disclosure", "_blank")}>
              <div className="pc-icon"><Disclosures /></div>
              <div className="pc-text">
                <span className="pc-label">Disclosure</span>
                <span className="pc-sub">Legal disclosures</span>
              </div>
              <RowChevron />
            </div>
            <div className="pc-row" onClick={window.open.bind(this, "https://www.stake.rent/legal/privacy-policy", "_blank")}>
              <div className="pc-icon"><Privacy /></div>
              <div className="pc-text">
                <span className="pc-label">Privacy Policy</span>
                <span className="pc-sub">How we protect your data</span>
              </div>
              <RowChevron />
            </div>

            <div className="pc-row pc-row-logout" onClick={InitLogout}>
              <div className="pc-icon"><Out /></div>
              <div className="pc-text">
                <span className="pc-label">Logout</span>
              </div>
              <RowChevron />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
